import { z } from "zod";
import { CHAIN_STRATEGY_VALUES } from "../../constants/chain-strategy.js";
import { CONVERGENCE_STRATEGY_VALUES } from "../../constants/convergence-strategy.js";
import { STORY_SYNOPSIS_MAX_LENGTH, STORY_TITLE_MAX_LENGTH, STORY_TITLE_MIN_LENGTH } from "../../constants/limits.js";
import { PRODUCTION_STATE_VALUES } from "../../constants/production-state.js";
import { RENDER_MODE_VALUES } from "../../constants/render-mode.js";
import { STORY_STATUS_VALUES } from "../../constants/story-status.js";
import { DecisionSchema } from "../narrative/decision.js";
import { EndingDefinitionSchema, EndingRuleSchema } from "../narrative/ending.js";
import { StoryFlagDefSchema } from "../narrative/flags.js";
export const createEpisodeSchema = z.object({
    title: z.string().min(STORY_TITLE_MIN_LENGTH).max(STORY_TITLE_MAX_LENGTH),
    synopsis: z.string().max(STORY_SYNOPSIS_MAX_LENGTH),
});
export const updateEpisodeSchema = createEpisodeSchema.partial();
export const AdminEpisodeSummarySchema = z.object({
    id: z.uuid(),
    seriesId: z.uuid(),
    episodeNumber: z.number().int().positive(),
    title: z.string(),
    status: z.enum(STORY_STATUS_VALUES),
    productionState: z.enum(PRODUCTION_STATE_VALUES),
    coverUrl: z.url().nullable(),
    likesCount: z.number().int().nonnegative(),
    commentsCount: z.number().int().nonnegative(),
    bookmarksCount: z.number().int().nonnegative(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const AdminShotSchema = z.object({
    id: z.uuid(),
    nodeId: z.uuid(),
    orderIndex: z.number().int().nonnegative(),
    purpose: z.string(),
    action: z.string(),
    endAction: z.string().nullable(),
    durationSeconds: z.number().positive(),
    locationId: z.uuid().nullable(),
    characterIds: z.array(z.uuid()),
    renderMode: z.enum(RENDER_MODE_VALUES),
    chainStrategy: z.enum(CHAIN_STRATEGY_VALUES),
    voiceoverText: z.string().nullable(),
    startFrameUrl: z.url().nullable(),
    endFrameUrl: z.url().nullable(),
    videoUrl: z.url().nullable(),
});
export const AdminNodeSchema = z.object({
    id: z.uuid(),
    title: z.string(),
    orderIndex: z.number().int().nonnegative(),
    convergenceStrategy: z.enum(CONVERGENCE_STRATEGY_VALUES).nullable(),
    decision: DecisionSchema.nullable(),
    nextNodeId: z.uuid().nullable(),
    endingId: z.uuid().nullable(),
    shots: z.array(AdminShotSchema),
});
export const AdminEpisodeDetailSchema = z.object({
    id: z.uuid(),
    seriesId: z.uuid(),
    episodeNumber: z.number().int().positive(),
    title: z.string(),
    synopsis: z.string(),
    status: z.enum(STORY_STATUS_VALUES),
    productionState: z.enum(PRODUCTION_STATE_VALUES),
    coverUrl: z.url().nullable(),
    entryNodeId: z.uuid().nullable(),
    likesCount: z.number().int().nonnegative(),
    commentsCount: z.number().int().nonnegative(),
    bookmarksCount: z.number().int().nonnegative(),
    createdAt: z.string(),
    updatedAt: z.string(),
    flags: z.array(StoryFlagDefSchema),
    nodes: z.array(AdminNodeSchema),
    endings: z.array(EndingDefinitionSchema),
    endingRules: z.array(EndingRuleSchema),
});
